import {Ability} from '~/lib/ability';
import {IAgency} from '~/modules/Clients/models/Agency';
import {IBlocking} from '~/modules/Clients/models/Blocking';
import {ISeller} from '~/modules/Clients/models/Seller';
import {ISource} from '~/modules/Sources/models/Source';

export class ClientsAbility extends Ability {
    canViewAgencies = () => this.isAdmin() || this.isManager();
    canDeleteAgency = (agency: IAgency) => this.isAdmin();
    canEditAgency = (agency: IAgency) => this.isAdmin();
    canCreateAgency = () => this.isAdmin();
    canCopyAgency = (agency: IAgency) => this.isAdmin();
    canBulkAssignAgencyPreset = () => this.isAdmin();

    canViewSellers = () => this.isAdmin() || this.isManager();
    canDeleteSeller = (seller: ISeller) => this.isAdmin();
    canEditSeller = (seller: ISeller) => this.isAdmin();
    canCreateSeller = () => this.isAdmin();
    canBulkAssignSellerPreset = () => this.isAdmin();
    canBulkUpdateConfigs = () => this.isAdmin();
    canEditGlobalSellerConfig = () => this.isAdmin();
    canEditGlobalAgencyConfig = () => this.isAdmin();

    canDeleteSource = (source: ISource) => this.isAdmin();
    canEditSource = (source: ISource) => this.isAdmin();
    canCreateSource = () => this.isAdmin();

    canDeleteBlocking = (blocking: IBlocking) => this.isAdmin() || this.isSelfServe();
    canEditBlocking = (blocking: IBlocking) => this.isAdmin() || this.isSelfServe();
    canCreateBlocking = () => this.isAdmin() || this.isSelfServe();

    canEditSensitiveCategories = () => this.isAdmin() || this.isSeller() || this.isSelfServe();
    canViewSensitiveCategoryReport = () => this.isAdmin();

    canViewAppAds = () => this.isAdmin();
}
